<template>
  <div class="pt-2">
    <!-- History Table -->
    <div class="overflow-x-auto overflow-y-auto">
      <v-data-table
        :headers="headers"
        :items="history"
        :search="search"
        :loading="loading"
        class="table-radius border border-[#e0e0e0]"
        fixed-header
      >
        <!-- Headers Styling -->
        <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
          <p
            :key="'header-tool-' + index"
            class="font-title"
            v-if="header.text?.length > 15"
            v-tooltip="{ text: header.text }"
          >
            {{ header.text }}
          </p>
          <p :key="'header-text-' + index" v-else class="font-title">{{ header.text }}</p>
        </template>

        <!-- Row Data Styling -->
        <template v-slot:item.productId.productName="{ item }">
          <td class="px-4 py-3 table-font">
            {{ item.productId ? item.productId.productName : 'N/A' }}
          </td>
        </template>
        <template v-slot:item.locationId.branchName="{ item }">
          <td class="px-4 table-font">
            {{ item.locationId ? item.locationId.branchName : 'N/A' }}
          </td>
        </template>
        <template v-slot:item.userId="{ item }">
          <td class="px-4 table-font">
            {{ item.userId ? `${item.userId.firstName} ${item.userId.lastName || ''}` : 'N/A' }}
          </td>
        </template>
        <template v-slot:item.handoverDate="{ item }">
          <td class="px-4 table-font">
            {{ item.handoverDate ? $dayjs(item.handoverDate).format('DD-MM-YYYY hh:mm A') : 'N/A' }}
          </td>
        </template>
        <template v-slot:item.allotmentDate="{ item }">
          <td class="px-4 table-font">
            {{ item.createdAt ? $dayjs(item.createdAt).format('DD-MM-YYYY hh:mm A') : 'N/A' }}
          </td>
        </template>
        <template v-slot:item.quantity="{ item }">
          <td class="px-4 table-font font-semibold">{{ item.quantity }}</td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllotmentHistoryTab',
  props: {
    search: {
      type: String,
      default: ''
    },
    locationId: {
      type: String,
      default: null
    },
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: 'Product', value: 'productId.productName', sortable: false },
        { text: 'Quantity', value: 'quantity', sortable: false },
        { text: 'Location', value: 'locationId.branchName', sortable: false },
        { text: 'Allotment Date', value: 'allotmentDate', sortable: false },
        { text: 'Handover To', value: 'userId', sortable: false },
        { text: 'Handover Date', value: 'handoverDate', sortable: false }
      ],
      history: []
    }
  },
  watch: {
    search(newVal) {
      this.fetchData()
    },
    locationId() {
      this.fetchData()
    },
    startDate() {
      this.fetchData()
    },
    endDate() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = {
          search: this.search || undefined,
          locationId: this.locationId || undefined,
          start: this.startDate || undefined,
          end: this.endDate || undefined
        }
        const res = await this.$axios.get('/inventory/product-allotment-history', { params })
        const items = res.data?.history || res.data?.data?.items || []
        this.history = Array.isArray(items) ? items : []
      } catch (e) {
        console.error('Error fetching allotment history', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.table-radius {
  border-radius: 0px !important;
}
.font-title {
  font-size: 0.875rem;
  color: #000;
  margin-bottom: 0px !important;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-font {
  font-size: 0.875rem;
  color: #374151;
}
</style>
